import { api } from "@api/api";
import { Partner } from "@modules/partners/types";

export async function getPartnerService(id: number | string): Promise<Partner> {
  const { data } = await api.get<Partner>(`/v1/partner_admin/${id}/`);
  return data;
}
